// Basic example of using lookup tables for simple effects
import * as THREE from "three";
import {Host} from "../engine/host";
import {AClock} from "../engine/clock";
import {TextureStore} from "../engine/utils";
import {preload} from "../engine/loader";
import {FullScreenQuadEntity} from "../engine/entity";
class Luts {
    resources() {
        return {
            'models': [],
            'shaders': [
                {
                    "path": "v_basic.glsl",
                    "name": "v_basic"
                },
                {
                    "path": "f_basic.glsl",
                    "name": "f_basic"
                },
                {
                    "path": "f_luts.glsl",
                    "name": "f_luts"
                },
                {
                    "path": "globals.glsl",
                    "name": "globals"
                },
            ],
            'gltf': [
            ],
            'textures': [
                {
                    'path': "dogs.jpg",
                    'name': 'dogs'
                },
                {
                    'path': "Cedar_shake_pxr128.png",
                    'name': 'bosworth'
                },
                {
                    "path": "crossline-dots.png",
                    "name": "pattern-1"
                },
                {
                    "path": "dark-honeycomb.png",
                    "name": "pattern-2"
                },
                {
                    "path": "positive.png",
                    "name": "pattern-3"
                },
                {
                    "path": "prism.png",
                    "name": "pattern-3"
                }
            ]
        };
    }
    constructor() {
        this.aclock = new AClock();
        this.dTime = 0.0;
        this.target = null;
        this.camera = null;
        this.shaders = [];
        this.entities = [];
        this.uniforms = {
            xPosition: {
                type: 'f',
                value: 0.0
            },
            yPosition: {
                type: 'f',
                value: 0.0
            },
            zPosition: {
                type: 'f',
                value: 0.0
            },
            scaleFactor: {
                type: 'f',
                value: 10000.0
            },
            spriteTilesWide: {
                type: 'f',
                value: 1.0
            },
            spriteTilesTall: {
                type: 'f',
                value: 1.0
            },
            spriteIndexX: {
                type: 'f',
                value: 0.0
            },
            spriteIndexY: {
                type: 'f',
                value: 0.0
            },
            spriteIndex: {
                type: 'f',
                value: 0.0
            },
            time: {
                type: 'f',
                value: 0.0
            },
            noiseMult: {
                type: 'f',
                value: 10.0
            },
            wireframe: {
                type: 'i',
                value: 0
            },
            color: {
                type: 'v3',
                value: new THREE.Vector3()
            },
            flatColor: {
                type: 'v3',
                value: new THREE.Color(0x000000)
            },
            diffuse: {
                type: 'c',
                value: new THREE.Color(0xaaeeff)
            },
            resolution: {
                type: 'v2',
                value: new THREE.Vector2()
            },
            mouse: {
                type: 'v2',
                value: new THREE.Vector2()
            },
            lightPosition: {
                type: 'v3',
                value: new THREE.Vector3()
            },
            cameraPos: {
                type: 'v3',
                value: new THREE.Vector3()
            },
            t0: {
                type: 't',
                value: TextureStore.getTexture('dogs')
            }
        };
    }
    // finally add a damn quad.
    addQuad() {
        var width = 2;
        var height = 3;
        var quad = new QuadEntity(
            this.scene,
            width,
            height,
            'v_basic',
            'f_luts');
        quad.setTexture('pattern-1');
        quad.uniforms.resolution.value.x = 128;
        quad.uniforms.resolution.value.y = 128;
        this.entities.push(quad);
        return quad;
    }
    setup(_sceneWidth, _sceneHeight) {
        this.sceneWidth = _sceneWidth;
        this.sceneHeight = _sceneHeight;
        this.uniforms.resolution.value.x = _sceneWidth;
        this.uniforms.resolution.value.y = _sceneHeight;
        this.scene = new THREE.Scene();
        this.camera = new THREE.PerspectiveCamera(67,
            _sceneWidth / _sceneHeight,
            0.001,
            1e20);
        var light = new THREE.AmbientLight(0xffffff);
        this.scene.add(light);
        this.camera.position.z = 30;
        // Adds the full screen quad
        this.quad = new FullScreenQuadEntity(this.scene,
            this.camera,
            this.sceneWidth,
            this.sceneHeight,
            'v_basic',
            'f_luts');
        this.quad.setTexture('bosworth');
        this.quad.uniforms.resolution.value.x = this.sceneWidth;
        this.quad.uniforms.resolution.value.y = this.sceneHeight;
        this.entities.push(this.quad);
        // add interactive quad type elements
        // var quad = this.addQuad();
        // quad.setPosition(new THREE.Vector3(0.0, 0.0, 20.0));
    }
    render(renderer) {
        this.aclock.update();
        this.uniforms["time"].value = this.aclock.dMS;
        this.uniforms.resolution.value.x = this.sceneWidth;
        this.uniforms.resolution.value.y = this.sceneHeight;
        renderer.render(this.scene, this.camera);
        for (let e of this.entities) {
            e.update(this.aclock);
        }
    }
}
// Primary attachment of the 'loader' to the host
document.addEventListener("DOMContentLoaded", function (event) {
    // Bind to the host, inject the graphics engine that we're interested in.
    let shost = new Luts();
    preload([shost], function () {
        const host = new Host(shost);
        host.setup();
    });
});

